import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CheckboxExcluded from "./CheckboxExcluded";
import { Colors } from "@flow/style";
import Tooltip from "./Tooltip";
import CheckboxRequired from "./CheckboxRequired";

const PacketRow = ({ isActive, selected, option, onSelect }) => {
  const {
    isRequired,
    isExcluded
  } = option

  return (
    <Row isActive={isActive}>
      <CheckboxRequired
        disabled={selected && isExcluded}
        isActive={isActive}
        checked={selected && isRequired}
        option={option}
        onClick={onSelect}
      />
      <CheckboxExcluded
        disabled={selected && isRequired}
        isActive={isActive}
        checked={selected && isExcluded}
        option={option}
        onClick={onSelect}
      />
      <PacketName isActive={isActive}>{option.optionName}</PacketName>
      <Tooltip text={option.attributes} />
      <Price>{option.price || option.retailPrice902 || 0} kr</Price>
    </Row>
  );
};

PacketRow.propTypes = {
  isActive: PropTypes.bool,
  selected: PropTypes.bool,
  id: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.number,
  basePrice: PropTypes.number,
  includes: PropTypes.array,
  excludes: PropTypes.array,
  requires: PropTypes.array,
  onClick: PropTypes.func
};

PacketRow.defaultProps = {
  isActive: false,
  selected: false,
  id: 0,
  name: "",
  price: 0,
  basePrice: 0,
  includes: [],
  excludes: [],
  requires: [],
  onClick: null
};

export default PacketRow;

export const Row = styled.div`
  display: flex;
  margin: 0 10;
  border-bottom: 1px solid #e4e2e2;
  padding: 10px 0 10px 0;
  line-height: 22px;
  font-size: 14px;
  cursor: ${props => (props.isActive ? "pointer" : "not-allowed")};
  display: grid;
  grid-template-columns: 75px 75px auto 50px 80px;
`;

export const PacketName = styled.div`
  padding-right: 15px;
  text-align: left;
  text-transform: capitalize;
  color: ${props => (props.isActive ? Colors.Grey1 : Colors.Grey3)};
  width: 460px;
`;

export const Price = styled.div`
  flex-grow: 2;
  text-align: right;
`;
